import React, { useCallback } from 'react'
import { Message } from '@weblite/ts-action/message'
import { useActiveSectionsTop } from 'weblite-router'
import { openedRoomPermissions } from '$logic/opened-room'
import { sendFieldApis } from '$comp/_app/components/chat/components/footer/components/send-field'
import { showContextMenu } from '$comp/modals/menus/context-menu'
import { isTouchAvailable } from '$func/environmentInfo'

export function useHandlers(
  roomId: string,
  messageId: string,
  messageIid: number,
  messageType: Message['type'],
  selected: boolean,
  isSelectionMode: boolean,
  toggleSelection: (iid: number) => unknown,
  isPending: boolean,
) {
  const openContextMenu = useCallback(
    (e: React.MouseEvent<HTMLLIElement>) => {
      if (!(roomId && messageIid)) return
      e.preventDefault()
      showContextMenu({
        roomId,
        iid: messageIid,
        xAxis: e.clientX,
        yAxis: e.clientY,
      })
    },
    [roomId, messageIid],
  )

  const onContextMenu = useCallback(
    (e: React.MouseEvent<HTMLLIElement>) => {
      e.preventDefault()
      if (isSelectionMode) return

      if (!isTouchAvailable) openContextMenu(e)
      // else toggleSelection(messageIid)
    },
    [messageIid],
  )

  const onLongPress = useCallback(async () => {
    if (isPending) return
    toggleSelection(messageIid)
  }, [messageIid, isPending])

  const onClick = useCallback(
    e => {
      if (isSelectionMode) {
        if (!isPending) toggleSelection(messageIid)
      } else if (
        // open context menu if clicked on text message (except links)
        ((messageType === 'TEXT' && e.target.tagName === 'DIV') ||
          messageType === 'EVENT' ||
          // or clicked on the outer space of image, file, wapp and voice messages
          e.target.id === messageId ||
          e.target.id === messageIid?.toString() ||
          e.target.parentElement.id === messageId ||
          e.target.parentElement.id === messageIid?.toString()) &&
        'ontouchstart' in window
      )
        openContextMenu(e)
    },
    [messageId, messageIid, isSelectionMode, toggleSelection, isPending],
  )

  const onDoubleClick = useCallback(() => {
    if (messageIid && !isSelectionMode)
      openedRoomPermissions().then(({ sendMessage }) => {
        if (sendMessage) sendFieldApis.setReplyContent(messageIid)
      })
  }, [messageIid])

  return { onClick, onDoubleClick, onContextMenu, onLongPress }
}

export function useShouldObserveMessages() {
  const activeSection = useActiveSectionsTop()
  return activeSection
    ? !['overlay', 'comm', 'story'].includes(activeSection)
    : false
}
